import {
  ADD_SERVICE_START,
  ADD_SERVICE_SUCCES,
  ADD_SERVICE_FAIL,
  GET_SERVICE_START,
  GET_SERVICE_SUCCES,
  GET_SERVICE_FAIL,
  SEARCH_SERVICE,
} from "./constant";

import ServicesMunicipality from "services/service.municipality";

export const insertService = (values) => (dispatch) => {
  dispatch({
    type: ADD_SERVICE_START,
  });
  return ServicesMunicipality.insertServiceMunicipal(values).then(
    (response) => {
      dispatch({
        type: ADD_SERVICE_SUCCES,
        payload: response.data,
      });

      return Promise.resolve();
    },
    () => {
      dispatch({
        type: ADD_SERVICE_FAIL,
      });
      return Promise.reject();
    }
  );
};

export const deleteServices = (id) => () => {
  return ServicesMunicipality.deleteServiceMunicipal(id).then(
    () => {
      return Promise.resolve();
    },
    () => {
      return Promise.reject();
    }
  );
};

export const setTextSearchService = (text) => (dispatch) => {
  dispatch({
    type: SEARCH_SERVICE,
    payload: text,
  });
};

export const getAllServices = () => (dispatch) => {
  dispatch({
    type: GET_SERVICE_START,
  });
  return ServicesMunicipality.getAllServiceMunicipal().then(
    (response) => {
      dispatch({
        type: GET_SERVICE_SUCCES,
        payload: response.data,
      });

      return Promise.resolve();
    },
    () => {
      dispatch({
        type: GET_SERVICE_FAIL,
      });
      return Promise.reject();
    }
  );
};
